import { render, staticRenderFns } from "./PaymentReport.vue?vue&type=template&id=22526d06&scoped=true&"
import script from "./PaymentReport.vue?vue&type=script&lang=js&"
export * from "./PaymentReport.vue?vue&type=script&lang=js&"
import style0 from "./PaymentReport.vue?vue&type=style&index=0&id=22526d06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22526d06",
  null
  
)

export default component.exports